function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M56.7 185.5l28.2 16.3v32.5l-28.2 16.3-28.2-16.3v-32.5l28.2-16.3m0-33L0 185.3v65.5l56.7 32.7 56.7-32.7v-65.5l-56.7-32.8zM64 134.7H49.5V82.6l63.9-36.9 45.7 26.4-7.3 12.5-38.4-22.2L64 91zM226.8 86.2l28.2 16.3V135l-28.2 16.3-28.2-16.3v-32.5l28.2-16.3m0-33L170.1 86v65.5l56.7 32.7 56.7-32.7V86l-56.7-32.8z"
})));